import { Stepper, Step, StepLabel, StepConnector, StepButton, useMediaQuery} from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import React, { useContext } from "react"
import {ReactComponent as DoneIcon} from './../../../assets/done-icon.svg';
import {ReactComponent as CurrentIcon} from './../../../assets/current-icon.svg'
import { QuoteContextStore } from '../../../context/QuoteContext/QuoteContext';
import { useHistory } from 'react-router-dom';
import { steps } from "../../../context/QuoteContext/actions";
import usePurchaseFlowParams from "../../PurchaseFlow/hooks/usePurchaseFlowParams";
const classnames = require('classnames')

const useStyles = makeStyles((theme) => ({
    root: {
      '&': {
        background: 'none',
        border: 'none',
        marginTop: 56,
        marginBottom: 60
      }
    },
    label: {
        '& .MuiStepLabel-label': {
            marginLeft: 10,
            fontFamily: `'Poppins-Regular' !important`,
            fontSize: 18,
            fontWeight: 'normal',
            textAlign: 'left',
            color: 'white',
            '&.MuiStepLabel-active': {
              color: '#55ccde !important',
              fontWeight: '600 !important'
            },        
            '&.MuiStepLabel-completed': {
              color: '#55ccde !important'
            },

        },
        [theme.breakpoints.down('sm')]: { 
          '& .MuiStepLabel-iconContainer': {
            padding: 0
          }
        }
    },
    horizontal: {
      padding: 0
    }
  }));

  const VerticalConnector = withStyles({
    root: {
        marginLeft: 'calc(35px/2)'
    },
    alternativeLabel: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
      },
    active: {
      '& $line': {
          background: '#55ccde',
          width: 0,
          borderLeft: '1px dotted #55ccde'
      },
    },
    completed: {
      '& $line': {
        borderColor: '#55ccde',
      },
    },
    line: {
      height: 3,
      border: 0,
      background: 'white',
      width: 0,
      borderLeft: '1px dotted white',
      minHeight: '40px',
      marginTop: '7px',
      borderRadius: 1,
    },
  })(StepConnector);


  const HorizontalConnector = withStyles({
    root: {
    },
    alternativeLabel: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
      },
    active: {
      '& $line': {
          borderColor: '#55ccde'
      },
    },
    completed: {
      '& $line': {
        borderColor: '#55ccde',
      },
    },
    line: {
      width: '100%',
      border: 0,
      background: 'white',
      borderTop: '1px solid white',
      borderRadius: 1
    },
  })(StepConnector);

const StepIcon = ({active, completed, icon: index}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const icons = {
        1: <span className="progress-inactive">{isMobile ? index : ''}</span>,
        2: <DoneIcon className="progress-done" />,
        3: <CurrentIcon className="progress-current"/>
    }
    const renderIcons = () => {
        if(active) {
            return icons[3];
        } else if (completed) {
            return icons[2];
        } else {
            return icons[1];
        }
    }

    return (
        <>
        {renderIcons()}
        </>
    )
}

const SkywatchStepper = ({horizontal,...props}) => {
    const stepNames = ["Profile", "Aircraft & Airport", "Pilot", "Coverage" , "Summary"];
    const {currentStep} = useContext(QuoteContextStore);
    const classes = useStyles();
    const history = useHistory();
    const { quoteId } = usePurchaseFlowParams();

    const handleStepChange = (nextStep) => {
      const stepName = Object.keys(steps).find(s => {
        return steps[s].step === nextStep
      });
      const url = steps[stepName].url;
      history.push(`${url}/${quoteId}`)
  }

    return (
        <Stepper className={classes.root} activeStep={currentStep} connector={ !horizontal ? <VerticalConnector /> : <HorizontalConnector/>} orientation={!horizontal ? "vertical" : "horizontal"}>
            {stepNames.map((label, index) => (    
            <Step className={classes.horizontal} key={label}>
              <StepButton onClick={() => handleStepChange(index)}>
                <StepLabel className={classes.label} StepIconComponent={StepIcon}>{!horizontal ? label : ""}</StepLabel> 
              </StepButton>
            </Step>
            ))}
        </Stepper>    
        )
}

export default SkywatchStepper;